import React, { Component } from "react";
import { Table, TableHead, TableRow, TableCell, TableBody, Icon, Grid } from "@material-ui/core";
import "./MatchList.css";
import PropTypes from "prop-types";
import { bucketUrl, prettyDates, capitalize } from "../../../../actions/utils";
import TenantIcon from '../../../../images/icons/tenant_icon.png';
import SplitPanel from "../../../Helpers/SplitPanel";
import LinkHelper from "../../../Helpers/Link";
import InfoPanel from "../../../Helpers/InfoPanel";
import { RESIDENCE_TYPES } from "../../../../constants";
import { connect } from "react-redux";


const logoList = []
for (let i = 101; i <= 200; i++) {
    logoList.push(require(`../../../../images/logo/logo${i}.png`));
}

const logoFromId = (id) => {
    const parsed = parseInt("1" + id.replaceAll(/[^0-9]/g, ""))
    return logoList[parsed % logoList.length]
}

const maxRoomCount = 6;
const empty = "-";
class TenantMatchList extends Component {

    constructor(props) {
        super(props);
        this.mapMatch = this.mapMatch.bind(this);
    }

    mapMatch(match) {

        const translateOccupation = (occupation) => {
            if (!occupation)
                return empty;
            let result = "";
            if (occupation.work)
                result = `${result}${result ? ", " : ""}Working`;
            if (occupation.student)
                result = `${result}${result ? ", " : ""}Student`;
            return result;
        }


        const translateArray = (array) => {
            if (!array)
                return empty;
            let matches;
            if (Array.isArray(array)) {
                matches = array;
            }
            else if (typeof array === "string") {
                if (array === "{}")
                    return empty;
                const arrayRegex = /"[^"]+"/g;
                const captures = array.match(arrayRegex);
                if (!captures)
                    matches = [array];
                else
                    matches = captures.map(m => m.substring(1, m.length - 1));
            }
            let result = "";
            for (let i = 0; i < matches.length; i++) {
                result = `${result}${result ? ", " : ""}${capitalize(matches[i])}`;
            }
            return result;
        }

        const translateString = (str) => {
            if (!str)
                return empty;
            return capitalize(str);
        }


        const translateResidenceType = (residenceType) => {
            if (!residenceType)
                return empty;
            let result = ""
            if (typeof residenceType === "string")
                result = [RESIDENCE_TYPES.find(item => item.value === residenceType)]
            if (result === "")
                result = residenceType
                    .map(type => RESIDENCE_TYPES.find(item => item.value === type))
            result = result.map(type => type ? type.displayName : undefined)
                .filter(Boolean)
                .join(", ")
            return result;
        }

        const translateRange = (min, max, postfix) => {
            if ((!min && min !== 0) && (!max && max !== 0))
                return empty;
            if (min === max) {
                return `${translateBigNumber(min)} ${postfix}`;
            }
            let usedMin = min;
            let usedMax = max;
            if ((!min && min !== 0))
                usedMin = 0;
            if ((!max && max !== 0))
                return `${translateBigNumber(Math.round(usedMin))}+ ${postfix}`
            return `${translateBigNumber(Math.round(usedMin))} - ${translateBigNumber(Math.round(usedMax))} ${postfix}`
        }

        const translateBigNumber = (number) => {
            return number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ")
        }

        const translateBoolObject = (input) => {
            if (!input)
                return empty;
            const obj = Array.isArray(input) ? input[0] : input;
            let result = "";
            Object.keys(obj).forEach(key => {
                if (obj[key] === true)
                    result = `${result}${result ? ", " : ""}${capitalize(key)}`;
            });
            return result || empty;
        }

        const translateDateRange = (from, to) => {
            return to
                ? (from
                    ? `${prettyDates.day(from)} - ${prettyDates.day(to)}`
                    : `Until ${prettyDates.day(to)}`)
                : (from
                    ? `${prettyDates.day(from)} -`
                    : empty)
        }

        const translateName = user => {
            if (user.privateTenant) {
                return `${user.privateTenant.firstName} ${user.privateTenant.lastName
                    }`;
            }
            if (user.organizationTenant) {
                return `${user.organizationTenant.name} - ${user.organizationTenant.contactFirstName
                    } ${user.organizationTenant.contactLastName}`;
            }
        };

        if (!match)
            return <div />;

        const user = match.tenant || (match.potentialTenant || {});
        const properties = user.properties ? (user.properties[0] || {}) : {};
        //const avatar = user.file ? `${bucketUrl}/${user.file.key}` : TenantIcon;
        const avatar = logoFromId(properties.id)
        const occupation = properties.occupation || {};
        // console.log( 'MATCH >>', match ); // DEBUG
        return (
            <TableRow
                key={user.id}
                className="MatchList-row"
            >
                <TableCell>
                    <div className="MatchList-row-hover-details">
                        <LinkHelper to={`/user/matches/${this.props.selectedAnnoId}/${properties.id}`}>
                            <img className="MatchList-row-preview" src={avatar} alt='profile' />
                        </LinkHelper>
                    </div>
                    <div className="MatchList-row-details">
                        <Grid container direction="row" justify="flex-start" alignItems="flex-start">
                            <img alt="Preview" src={avatar} />
                            <div className="MatchList-row-details-textarea">
                                <div className="MatchList-row-details-description">
                                    {user.description}
                                </div>
                                <SplitPanel
                                    left={
                                        <div className="MatchList-row-details-panel">
                                            <InfoPanel
                                                compact
                                                thin
                                                rows={[
                                                    ["Rent (month):", translateRange(properties.rentMin, properties.rent, "€")],
                                                    ["Rent (year):", translateRange(12 * properties.rentMin, 12 * properties.rent, "€")],
                                                    ["Size:", translateRange(properties.size, properties.sizeMax, "m²")],
                                                ]}
                                            />
                                        </div>
                                    }
                                    right={
                                        <div className="MatchList-row-details-panel">
                                            <InfoPanel
                                                compact
                                                thin
                                                rows={[
                                                    ["Type:", translateResidenceType(properties.residenceType)],
                                                    ["Rent period:", translateDateRange(properties.whenAvailable, properties.moveOutDate)],
                                                    occupation.work ? ["Work details:", translateString(occupation.workDetails)] : undefined,
                                                    occupation.student ? ["Study details:", translateString(occupation.studentDetails)] : undefined,
                                                ]}
                                            />
                                        </div>
                                    }
                                />
                            </div>
                        </Grid>
                    </div>
                </TableCell>
                <TableCell>
                    <div>{translateName(user)}</div>
                </TableCell>
                {/* <TableCell>{prettyDates.year( user.birthday )}</TableCell>
                <TableCell>{translateOccupation( user.occupation )}</TableCell>*/}
                <TableCell>{translateDateRange(properties.whenAvailable, properties.moveOutDate)}</TableCell>
                <TableCell>{match.points}%</TableCell>
                {/* <TableCell><Icon className={match.personPoints > 3 ? "MatchList-row-personality-match" : "MatchList-row-personality"}>{match.personPoints > 3 ? "thumb_up" : "thumb_down"}</Icon></TableCell> */}
                <TableCell><Icon className={"MatchList-row-personality-match"}>{"thumb_up"}</Icon></TableCell>
                {/* TODO: Add favorite tenants to landlord if necessary */}
                {/* <TableCell>
                        <Icon
                            className={match.favorite ? "MatchList-row-icon-favorite" : "MatchList-row-icon"}
                            onClick={() => {
                                if ( this.props.setFavorite )
                                    this.props.setFavorite( match.id, !match.favorite )
                            }}
                        >
                            {match.favorite ? "favorite" : "favorite_border"}
                        </Icon>
                </TableCell> */}
            </TableRow>
        );
    }

    render() {
        const { matches } = this.props;
        // console.log( "MATCHES >>", matches );
        return (
            <Table>
                <colgroup>
                    <col width="10%" />{/* Tenant list */}
                    <col width="30%" />{/* Name */}
                    <col width="20%" />{/* Rent period */}
                    <col width="10%" />{/* Match with property */}
                    <col width="15%" />{/* Match with your requirements */}
                    {/* <col width="5%"/> */}{/* Favorite */}
                </colgroup>
                <TableHead>
                    <TableRow>
                        <TableCell style={{ fontWeight: 'bold' }}>Tenant list</TableCell>
                        <TableCell style={{ fontWeight: 'bold' }}>Name</TableCell>
                        <TableCell style={{ fontWeight: 'bold' }}>Rent Period</TableCell>
                        <TableCell style={{ fontWeight: 'bold' }}>Match with Property</TableCell>
                        <TableCell style={{ fontWeight: 'bold' }}>Match with Additional Requirements</TableCell>
                        {/* <TableCell>Favorite</TableCell> */}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {/* <TableRow/> */}
                    {matches.map(this.mapMatch)}
                </TableBody>
            </Table>
        );
    }

}

TenantMatchList.propTypes = {
    setFavorite: PropTypes.func.isRequired,
    matches: PropTypes.array.isRequired
}

export default connect(
    state => ({
        selectedAnnoId: state.landlord.selectedAnnouncement
    })
)(TenantMatchList);